import {
  Companion_getInstance19tkudxb52ql0 as Companion_getInstance,
  MailCheckPhysicallytriaqfbh0a67 as MailCheckPhysically,
  ConfirmedShippedhfotfv6hc5c1 as ConfirmedShipped,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Addresscpovxna1tjmg as Address,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from './supportModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareMailCheckPhysicallyFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [MailCheckPhysically__id_getInstance(), MailCheckPhysically_user_getInstance(), MailCheckPhysically_project_getInstance(), MailCheckPhysically_name_getInstance(), MailCheckPhysically_address_getInstance(), MailCheckPhysically_amount_getInstance(), MailCheckPhysically_confirmed_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function MailCheckPhysically__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function MailCheckPhysically__id$_get_name_$ref_j2qpfh() {
  return (p0) => p0.k20();
}
function MailCheckPhysically__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function MailCheckPhysically__id$_get_serializer_$ref_4k2ul8() {
  return (p0) => p0.j2j();
}
function MailCheckPhysically__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function MailCheckPhysically__id$_get_annotations_$ref_gvgu6w() {
  return (p0) => p0.bz();
}
var MailCheckPhysically__idClass;
function MailCheckPhysically__id() {
  if (MailCheckPhysically__idClass === VOID) {
    class $ {
      constructor() {
        MailCheckPhysically__id_instance = this;
        var tmp = this;
        tmp.z6q_1 = lazy(MailCheckPhysically__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a6r_1 = lazy(MailCheckPhysically__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b6r_1 = lazy(MailCheckPhysically__id$annotations$delegate$lambda);
        this.c6r_1 = Companion_getInstance_0().m2p();
        this.d6r_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.z6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, MailCheckPhysically__id$_get_name_$ref_j2qpfh(), null);
        return tmp0.f2();
      }
      e6r(receiver) {
        return receiver.f6r_1;
      }
      m2j(receiver) {
        return this.e6r(receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE());
      }
      m6r(receiver, value) {
        return receiver.n6r(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE();
        return this.m6r(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, MailCheckPhysically__id$_get_serializer_$ref_4k2ul8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, MailCheckPhysically__id$_get_annotations_$ref_gvgu6w(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'MailCheckPhysically__id', VOID, VOID, [SerializableProperty()]);
    MailCheckPhysically__idClass = $;
  }
  return MailCheckPhysically__idClass;
}
var MailCheckPhysically__id_instance;
function MailCheckPhysically__id_getInstance() {
  if (MailCheckPhysically__id_instance === VOID)
    new (MailCheckPhysically__id())();
  return MailCheckPhysically__id_instance;
}
function MailCheckPhysically_user$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function MailCheckPhysically_user$_get_name_$ref_2b5hz6() {
  return (p0) => p0.k20();
}
function MailCheckPhysically_user$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function MailCheckPhysically_user$_get_serializer_$ref_2sd9uf() {
  return (p0) => p0.j2j();
}
function MailCheckPhysically_user$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function MailCheckPhysically_user$_get_annotations_$ref_pdnar() {
  return (p0) => p0.bz();
}
var MailCheckPhysically_userClass;
function MailCheckPhysically_user() {
  if (MailCheckPhysically_userClass === VOID) {
    class $ {
      constructor() {
        MailCheckPhysically_user_instance = this;
        var tmp = this;
        tmp.o6r_1 = lazy(MailCheckPhysically_user$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p6r_1 = lazy(MailCheckPhysically_user$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q6r_1 = lazy(MailCheckPhysically_user$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.o6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, MailCheckPhysically_user$_get_name_$ref_2b5hz6(), null);
        return tmp0.f2();
      }
      e6r(receiver) {
        return receiver.g6r_1;
      }
      m2j(receiver) {
        return this.e6r(receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE());
      }
      m6r(receiver, value) {
        return receiver.n6r(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE();
        return this.m6r(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, MailCheckPhysically_user$_get_serializer_$ref_2sd9uf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, MailCheckPhysically_user$_get_annotations_$ref_pdnar(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'MailCheckPhysically_user', VOID, VOID, [SerializableProperty()]);
    MailCheckPhysically_userClass = $;
  }
  return MailCheckPhysically_userClass;
}
var MailCheckPhysically_user_instance;
function MailCheckPhysically_user_getInstance() {
  if (MailCheckPhysically_user_instance === VOID)
    new (MailCheckPhysically_user())();
  return MailCheckPhysically_user_instance;
}
function MailCheckPhysically_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function MailCheckPhysically_project$_get_name_$ref_g0x8jg() {
  return (p0) => p0.k20();
}
function MailCheckPhysically_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function MailCheckPhysically_project$_get_serializer_$ref_m9pgo3() {
  return (p0) => p0.j2j();
}
function MailCheckPhysically_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function MailCheckPhysically_project$_get_annotations_$ref_3ui4hz() {
  return (p0) => p0.bz();
}
var MailCheckPhysically_projectClass;
function MailCheckPhysically_project() {
  if (MailCheckPhysically_projectClass === VOID) {
    class $ {
      constructor() {
        MailCheckPhysically_project_instance = this;
        var tmp = this;
        tmp.r6r_1 = lazy(MailCheckPhysically_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s6r_1 = lazy(MailCheckPhysically_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t6r_1 = lazy(MailCheckPhysically_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, MailCheckPhysically_project$_get_name_$ref_g0x8jg(), null);
        return tmp0.f2();
      }
      e6r(receiver) {
        return receiver.h6r_1;
      }
      m2j(receiver) {
        return this.e6r(receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE());
      }
      m6r(receiver, value) {
        return receiver.n6r(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE();
        return this.m6r(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, MailCheckPhysically_project$_get_serializer_$ref_m9pgo3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, MailCheckPhysically_project$_get_annotations_$ref_3ui4hz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'MailCheckPhysically_project', VOID, VOID, [SerializableProperty()]);
    MailCheckPhysically_projectClass = $;
  }
  return MailCheckPhysically_projectClass;
}
var MailCheckPhysically_project_instance;
function MailCheckPhysically_project_getInstance() {
  if (MailCheckPhysically_project_instance === VOID)
    new (MailCheckPhysically_project())();
  return MailCheckPhysically_project_instance;
}
function MailCheckPhysically_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function MailCheckPhysically_name$_get_name_$ref_t87ldu() {
  return (p0) => p0.k20();
}
function MailCheckPhysically_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function MailCheckPhysically_name$_get_serializer_$ref_dp7nmf() {
  return (p0) => p0.j2j();
}
function MailCheckPhysically_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function MailCheckPhysically_name$_get_annotations_$ref_hks22b() {
  return (p0) => p0.bz();
}
var MailCheckPhysically_nameClass;
function MailCheckPhysically_name() {
  if (MailCheckPhysically_nameClass === VOID) {
    class $ {
      constructor() {
        MailCheckPhysically_name_instance = this;
        var tmp = this;
        tmp.u6r_1 = lazy(MailCheckPhysically_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v6r_1 = lazy(MailCheckPhysically_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w6r_1 = lazy(MailCheckPhysically_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, MailCheckPhysically_name$_get_name_$ref_t87ldu(), null);
        return tmp0.f2();
      }
      e6r(receiver) {
        return receiver.i6r_1;
      }
      m2j(receiver) {
        return this.e6r(receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE());
      }
      x6r(receiver, value) {
        return receiver.n6r(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE();
        return this.x6r(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, MailCheckPhysically_name$_get_serializer_$ref_dp7nmf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, MailCheckPhysically_name$_get_annotations_$ref_hks22b(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'MailCheckPhysically_name', VOID, VOID, [SerializableProperty()]);
    MailCheckPhysically_nameClass = $;
  }
  return MailCheckPhysically_nameClass;
}
var MailCheckPhysically_name_instance;
function MailCheckPhysically_name_getInstance() {
  if (MailCheckPhysically_name_instance === VOID)
    new (MailCheckPhysically_name())();
  return MailCheckPhysically_name_instance;
}
function MailCheckPhysically_address$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function MailCheckPhysically_address$_get_name_$ref_bixsc7() {
  return (p0) => p0.k20();
}
function MailCheckPhysically_address$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function MailCheckPhysically_address$_get_serializer_$ref_s2sl26() {
  return (p0) => p0.j2j();
}
function MailCheckPhysically_address$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function MailCheckPhysically_address$_get_annotations_$ref_y4yjoe() {
  return (p0) => p0.bz();
}
var MailCheckPhysically_addressClass;
function MailCheckPhysically_address() {
  if (MailCheckPhysically_addressClass === VOID) {
    class $ {
      constructor() {
        MailCheckPhysically_address_instance = this;
        var tmp = this;
        tmp.y6r_1 = lazy(MailCheckPhysically_address$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z6r_1 = lazy(MailCheckPhysically_address$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a6s_1 = lazy(MailCheckPhysically_address$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.y6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, MailCheckPhysically_address$_get_name_$ref_bixsc7(), null);
        return tmp0.f2();
      }
      e6r(receiver) {
        return receiver.j6r_1;
      }
      m2j(receiver) {
        return this.e6r(receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE());
      }
      b6s(receiver, value) {
        return receiver.n6r(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE();
        return this.b6s(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z6r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, MailCheckPhysically_address$_get_serializer_$ref_s2sl26(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, MailCheckPhysically_address$_get_annotations_$ref_y4yjoe(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'MailCheckPhysically_address', VOID, VOID, [SerializableProperty()]);
    MailCheckPhysically_addressClass = $;
  }
  return MailCheckPhysically_addressClass;
}
var MailCheckPhysically_address_instance;
function MailCheckPhysically_address_getInstance() {
  if (MailCheckPhysically_address_instance === VOID)
    new (MailCheckPhysically_address())();
  return MailCheckPhysically_address_instance;
}
function MailCheckPhysically_amount$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function MailCheckPhysically_amount$_get_name_$ref_caexw1() {
  return (p0) => p0.k20();
}
function MailCheckPhysically_amount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function MailCheckPhysically_amount$_get_serializer_$ref_q204q() {
  return (p0) => p0.j2j();
}
function MailCheckPhysically_amount$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function MailCheckPhysically_amount$_get_annotations_$ref_6c11ju() {
  return (p0) => p0.bz();
}
var MailCheckPhysically_amountClass;
function MailCheckPhysically_amount() {
  if (MailCheckPhysically_amountClass === VOID) {
    class $ {
      constructor() {
        MailCheckPhysically_amount_instance = this;
        var tmp = this;
        tmp.c6s_1 = lazy(MailCheckPhysically_amount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d6s_1 = lazy(MailCheckPhysically_amount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e6s_1 = lazy(MailCheckPhysically_amount$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.c6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, MailCheckPhysically_amount$_get_name_$ref_caexw1(), null);
        return tmp0.f2();
      }
      f6s(receiver) {
        return receiver.k6r_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.f6s(receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE()));
      }
      g6s(receiver, value) {
        return receiver.n6r(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE();
        return this.g6s(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, MailCheckPhysically_amount$_get_serializer_$ref_q204q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, MailCheckPhysically_amount$_get_annotations_$ref_6c11ju(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'MailCheckPhysically_amount', VOID, VOID, [SerializableProperty()]);
    MailCheckPhysically_amountClass = $;
  }
  return MailCheckPhysically_amountClass;
}
var MailCheckPhysically_amount_instance;
function MailCheckPhysically_amount_getInstance() {
  if (MailCheckPhysically_amount_instance === VOID)
    new (MailCheckPhysically_amount())();
  return MailCheckPhysically_amount_instance;
}
function MailCheckPhysically_confirmed$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function MailCheckPhysically_confirmed$_get_name_$ref_oixpfm() {
  return (p0) => p0.k20();
}
function MailCheckPhysically_confirmed$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function MailCheckPhysically_confirmed$_get_serializer_$ref_63f0rt() {
  return (p0) => p0.j2j();
}
function MailCheckPhysically_confirmed$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function MailCheckPhysically_confirmed$_get_annotations_$ref_81pfgt() {
  return (p0) => p0.bz();
}
var MailCheckPhysically_confirmedClass;
function MailCheckPhysically_confirmed() {
  if (MailCheckPhysically_confirmedClass === VOID) {
    class $ {
      constructor() {
        MailCheckPhysically_confirmed_instance = this;
        var tmp = this;
        tmp.h6s_1 = lazy(MailCheckPhysically_confirmed$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i6s_1 = lazy(MailCheckPhysically_confirmed$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j6s_1 = lazy(MailCheckPhysically_confirmed$annotations$delegate$lambda);
        this.k6s_1 = null;
        this.l6s_1 = 'null';
      }
      k20() {
        var tmp0 = this.h6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, MailCheckPhysically_confirmed$_get_name_$ref_oixpfm(), null);
        return tmp0.f2();
      }
      e6r(receiver) {
        return receiver.l6r_1;
      }
      m2j(receiver) {
        return this.e6r(receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE());
      }
      m6s(receiver, value) {
        return receiver.n6r(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof MailCheckPhysically() ? receiver : THROW_CCE();
        return this.m6s(tmp, (value == null ? true : value instanceof ConfirmedShipped()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, MailCheckPhysically_confirmed$_get_serializer_$ref_63f0rt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, MailCheckPhysically_confirmed$_get_annotations_$ref_81pfgt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'MailCheckPhysically_confirmed', VOID, VOID, [SerializableProperty()]);
    MailCheckPhysically_confirmedClass = $;
  }
  return MailCheckPhysically_confirmedClass;
}
var MailCheckPhysically_confirmed_instance;
function MailCheckPhysically_confirmed_getInstance() {
  if (MailCheckPhysically_confirmed_instance === VOID)
    new (MailCheckPhysically_confirmed())();
  return MailCheckPhysically_confirmed_instance;
}
//region block: exports
export {
  prepareMailCheckPhysicallyFields as prepareMailCheckPhysicallyFields1bmujxna89sjm,
};
//endregion

//# sourceMappingURL=MailCheckPhysicallyFields.mjs.map
